import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';
import i18n from './localization';

import './styles/main.scss';

require('./filters/date');

Vue.config.productionTip = false;

/* eslint-disable no-new */
const instance = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: { App }
});

import { currencyFilter } from './filters/euro';

Vue.filter('currency', currencyFilter);

export default instance;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main.ts